<template>
  <div class="fixed inset-x-0 inset-y-0 notification">
    <transition name="notification" v-if="type == 'success'">
      <div v-show="visibility" class="fixed inset-x-0 inset-y-0 notificationText">
        <div v-for="(content, index) in contents" :key="index"
          style="width: 358px;height:auto;min-height: 65px; background: rgb(214, 255, 211);"
          class="px-4 py-2 fixed flex justify-center items-center inset-x-0 top-32 mx-auto text-black">
          <span class="ml-1 align-middle text-lg" style="color:rgb(72, 159, 66);white-space:pre-line">{{ content
          }}</span>
        </div>
      </div>
    </transition>
    <transition name="notification" v-else-if="type == 'error'">
      <div v-show="visibility" class="fixed inset-x-0 inset-y-0 notificationText">
        <div v-for="(content, index) in contents" :key="index"
          style="width: 358px;height:auto;min-height: 65px;background: rgb(255, 199, 199);"
          class="px-4 py-2 fixed flex justify-center items-center inset-x-0 top-32 mx-auto text-black error-notification">
          <span class="ml-1 align-middle text-lg" style="color:rgb(255, 0, 0);white-space:pre-line">
            {{ content }}
            <span v-if="moreContent" class="underline cursor-pointer" @click="moreClick">{{ moreContent }}</span>
          </span>
        </div>
      </div>
    </transition>
    <transition name="notification" v-else>
      <div v-show="visibility" class="fixed inset-x-0 inset-y-0 notificationText">
        <div v-for="(content, index) in contents" :key="index"
          class="w-80 px-4 py-2 rounded-xl mt-4 mx-auto bg-white text-black border-2 border-black-1">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd" />
          </svg>
          <span class="ml-1 align-middle">{{ content }}</span>
        </div>
      </div>
    </transition>
    <transition name="notificationBg">
      <div v-show="visibility" class="fixed inset-x-0 inset-y-0"
        style="background: rgb(255, 255, 255,0.5);white-space:pre-line;z-index: 2;">
      </div>
    </transition>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";

// router在.js文件中无法使用
// import { useRouter } from "vue-router";
// const router = useRouter()

// function goPaymentMethod(){
//   console.log(router,112)
//   router.push({name:'Personal',params:{linkChild:'paymentMethod'}})
// }


const props = defineProps({
  type: { type: String, default: 'warning', },
  contents: { type: Array },
  moreContent: {},
  delay: { type: Number, default: 3000 },
  handleRemove: { type: Function, default: () => { } },
});
const visibility = ref(false);
onMounted(() => {
  visibility.value = true;
  setTimeout(() => {
    visibility.value = false;
    setTimeout(() => {
      props.handleRemove();
    }, 500);
  }, props.delay);
});

function moreClick() {
  router.push({ name: 'Personal', params: { linkChild: 'paymentMethod' } })
}
</script>
<style scoped>
.notificationText {
  z-index: 10;
}

.notification {
  z-index: 99999;
}

.notification-enter-active,
.notification-leave-active {
  transition: 0.5s;
}

.notification-enter-from,
.notification-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.notificationBg-enter-active,
.notificationBg-leave-active {
  transition: 0.5s;
}

.notificationBg-enter-from,
.notificationBg-leave-to {
  opacity: 0;
}
</style>
